import { useState } from "react";
import { Button } from "@material-tailwind/react";
import { ArrowDownTrayIcon } from "@heroicons/react/24/solid";
import { WorkorderExportService } from "../../services/export/WorkorderExportService";

/**
 * Props pour le composant ExportCSVButton
 */
interface ExportCSVButtonProps {
  workorder: EasyTech.Workorder;
  className?: string;
  children?: React.ReactNode;
}

/**
 * Bouton permettant d'exporter les données du workorder au format CSV
 */
export function ExportCSVButton({
  workorder,
  className = "",
  children,
}: ExportCSVButtonProps) {
  const [isLoading, setIsLoading] = useState(false);

  /**
   * Exporte le workorder au format XLSX et déclenche le téléchargement
   */
  const handleExportClick = async () => {
    setIsLoading(true);

    try {
      // Création du service d'export et génération du XLSX
      const service = new WorkorderExportService();
      service.exportWorkorderAsXlsx(workorder);
    } catch (error) {
      console.error("Erreur lors de l'exportation:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Rendu avec children si fournis
  if (children) {
    return (
      <div className={className} onClick={handleExportClick}>
        {children}
      </div>
    );
  }

  // Rendu avec bouton standard
  return (
    <Button
      className={className}
      onClick={handleExportClick}
      disabled={isLoading}
      variant="filled"
      color="blue"
    >
      {isLoading ? (
        <span className="flex items-center">
          <span className="mr-2">Chargement...</span>
        </span>
      ) : (
        <span className="flex items-center">
          <ArrowDownTrayIcon className="h-4 w-4 mr-2" />
          Exporter XLSX
        </span>
      )}
    </Button>
  );
}
